<!-- Marker column: event pastille + the rail segment that links it to the next entry -->
<div class="relative flex w-6 flex-none justify-center">
  <!-- my-1 centres the 24px pastille inside the 32px box of the first content line, whose height the
       avatar sets: that is what keeps the icon and the text on the same line. -->
  <span
    [attr.aria-label]="eventLabelKey() | translate"
    [class]="markerClasses()"
    [title]="eventLabelKey() | translate"
    class="relative z-10 my-1 flex h-6 w-6 flex-none items-center justify-center rounded-full border">
    <span [class]="iconClass()" aria-hidden="true" class="pi text-[0.65rem]"></span>
  </span>
  @if (!isLast()) {
    <!-- top-8 clears the pastille and its my-1; -bottom-5 spans this row's pb-2.5 plus the next row's
         pt-2.5, so the segments join unbroken -->
    <span aria-hidden="true" class="absolute top-8 -bottom-5 left-1/2 w-px -translate-x-1/2 bg-primary-100"></span>
  }
</div>

<!-- Content column -->
<div class="flex min-w-0 flex-1 flex-col gap-1 pr-2">

  <!-- The customer leads the line: on a dashboard reading every customer at once, it is what tells
       the entries apart. The product chain follows and is the half the truncation eats first. -->
  <!-- min-h-8 is the avatar height: it pins this line to the same 32px box as the marker pastille. -->
  <div class="flex min-h-8 min-w-0 items-center gap-2">
    <span [title]="entryLabel()" class="min-w-0 flex-1 truncate leading-snug">
      <span class="font-semibold">{{ entry().customerName }}</span>
      <span aria-hidden="true" class="text-[var(--p-surface-400)]">&nbsp;·&nbsp;</span>
      @if (parentProductName()) {
        <span class="text-[var(--p-surface-500)]">{{ parentProductName() }}</span>
        <span aria-hidden="true" class="text-[var(--p-surface-400)]">&nbsp;›&nbsp;</span>
      }
      <span class="text-[var(--p-surface-700)]">{{ entry().productName }}</span>
    </span>
    <span class="flex-none text-xs whitespace-nowrap tabular-nums text-[var(--p-surface-600)]">
      {{ entry().createdAt | date: 'dd/MM/yyyy HH:mm' }}
    </span>
    @if (entry().createdBy) {
      <elcia-avatar [avatars]="authors()" [maxItem]="1" class="flex-none"/>
    } @else {
      <span
        [attr.aria-label]="'product-customer.history.unknown-author' | translate"
        [title]="'product-customer.history.unknown-author' | translate"
        class="pi pi-user flex-none text-xs text-[var(--p-surface-400)]"></span>
    }
  </div>

  <!-- One row per changed field. del/ins convey before/after structurally, so the strikethrough is
       never the only cue; values are clamped to keep long descriptions from stretching the row. -->
  @if (changes().length > 0) {
    <div class="mt-0.5 flex flex-col gap-0.5 border-l-2 border-primary-50 pl-3">
      @for (change of changes(); track $index) {
        <div class="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5 text-xs">
          <span class="text-[var(--p-surface-600)]">
            {{ 'product-customer.history.change-label' | translate: {field: change.label} }}
          </span>
          <del
            class="line-clamp-2 min-w-0 break-words text-[var(--p-surface-600)] line-through decoration-[var(--p-surface-400)]">{{ change.oldValue }}
          </del>
          <span aria-hidden="true" class="flex-none text-[var(--p-surface-600)]">&rarr;</span>
          <ins
            class="line-clamp-2 min-w-0 break-words font-semibold text-[var(--p-surface-800)] no-underline">{{ change.newValue }}
          </ins>
        </div>
      }
    </div>
  }

</div>
